module.exports = __webpack_public_path__ + "static/media/otherThings3.a5b01a81.png";